<template lang="pug">

transition(
  appear
)
  .icon-arrow
    svg(width="100%" viewBox="0 0 13 28" fill="none" xmlns="http://www.w3.org/2000/svg")
      path(d="M1 1 L12 14 L1 27" stroke="#fff" stroke-width="2" stroke-linejoin="round" stroke-linecap="round")
      //path(d="M.266 1.97c3.3 4.2 6.7 8.3 10 12.5v-1.6c-3.3 4.2-6.7 8.3-10 12.5-.9 1.1.7 2.7 1.6 1.6 3.3-4.2 6.7-8.3 10-12.5.4-.5.4-1.1 0-1.6-3.4-4.2-6.7-8.3-10-12.5-.9-1.1-2.5.5-1.6 1.6z" fill="#fff")



</template>

<script>
export default {
  name: 'icon-arrow',
  components: {},
  data() {
    return {}
  },
  props: {},
  computed: {},
  mounted() {},
  beforeDestroy() {},
  methods: {},
  watch: {},
}
</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"
.icon-arrow
  width: 100%
  //overflow: hidden









</style>
